import { createGlobalStyle, css } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    ${() => {
      return css`
        font-size: 62.5%;
        font-family: ${props => props.theme.typography.fontFamily};
      `;
    }}
  }`;

export default GlobalStyle;
